import { useLoanDocument } from '../../hooks/useLoanDocument';

export function useFixedSumLoanAgreement() {
  const {
    loanDocument,
    signLoanDocument,
    downloadLoanDocument,
    canSignLoanDocument,
    isLoanDocumentSigned,
  } = useLoanDocument('master_loan_agreement');

  return {
    fixedSumLoanAgreement: loanDocument,
    downloadFixedSumLoanAgreement: downloadLoanDocument,
    signFixedSumLoanAgreement: signLoanDocument,
    canSignFixedSumLoanAgreement: canSignLoanDocument,
    isFixedSumLoanAgreementSigned: isLoanDocumentSigned,
  };
}
